import { isDefined, isValidBoolean, isValidNumber, isValidText } from "../../../system/validators";
import { ShipmentForm } from "../../../system/Domain";

/**
 * Checks whether steps 1-7 (Fahrgestellnummer .. Reklamation Anderes) of a shipment-form are filled in,
 * i.e. everything except the shared "Fahrzeugabholung" and "Unterschriften" steps that a collection
 * session fills once and applies to every vehicle.
 */
export default function shipmentFormPreDeliveryValid(r: ShipmentForm | undefined | null): boolean {
	if (!r) return false;

	return (
		isDefined(r.conditionAndEquipment)
		&& isValidBoolean(r.conditionAndEquipment.correctVin)
		&& isValidBoolean(r.conditionAndEquipment.inspectionReports)
		&& isValidNumber(r.conditionAndEquipment.mileage)
		&& isValidBoolean(r.conditionAndEquipment.serviceBooklet)
		&& isValidBoolean(r.conditionAndEquipment.serviceRecord)
		&& isValidBoolean(r.conditionAndEquipment.radio)
		&& isValidBoolean(r.conditionAndEquipment.navigationDevice)
		&& isValidBoolean(r.conditionAndEquipment.navigationDataMedium)

		&& isDefined(r.installedTiresAndRims)
		&& isValidText(r.installedTiresAndRims?.tireType)
		&& isValidText(r.installedTiresAndRims?.rimType)

		&& isValidBoolean(r.additionalTiresAndRims)
		&& (!r.additionalTiresAndRims || (
			isValidText(r.suppliedTiresAndRims?.tireType)
			&& isValidText(r.suppliedTiresAndRims?.rimType)
		))
		&& isDefined(r.keys)
		&& isValidNumber(r.keys.vehicleKeys)
		&& isValidNumber(r.keys.workshopKeys)
		&& isValidNumber(r.keys.remoteControls)
		&& isDefined(r.accessories)
		&& isDefined(r.accessories.trailerHitch)
		&& isValidText(r.accessories.trailerHitch.hitch)
		&& ((r.accessories.trailerHitch.hitch == "None") || isValidNumber(r.accessories.trailerHitch.keys))
		&& isValidBoolean(r.accessories.loadSecuringNet)
		&& isValidBoolean(r.accessories.bootCover)
		&& isValidBoolean(r.accessories.isChargingCable)
		&& (!r.accessories.isChargingCable || isValidNumber(r.accessories.chargingCables))
	);
}
